import {PermissionType} from "@services";

export type MenuItem = {
    text: string;
    icon?: string;
    path: string;
    expanded?: boolean;
    items?: MenuItem[];
    permission?: PermissionType | PermissionType[];
};

export const navigation: MenuItem[] = [
    {
        text: 'Dashboard',
        icon: 'fa-light fa-chart-pie',
        path: '/dashboard',
        permission: PermissionType.DashboardMyScore,
    },
    {
        text: 'File Import',
        icon: 'fa-light fa-file-import',
        path: '/file-imports',
        permission: PermissionType.FileImports,
    },
    {
        text: 'Attendance',
        icon: 'fa-light fa-users',
        path: '',
        expanded: true,
        items: [
            {
                text: 'My Score',
                path: '/my-score',
                icon: 'fa-light fa-circle',
                permission: PermissionType.MyScore,
            },
            {
                text: 'Employees',
                path: '/employees',
                icon: 'fa-light fa-circle',
                permission: PermissionType.EmployeesList,
            },
            {
                text: 'Schedule',
                path: '/scheduler',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Schedule,
            },
            {
                text: 'Time Logs',
                path: '/time-logs',
                icon: 'fa-light fa-circle',
                permission: PermissionType.TimeLogs,
            },
            {
                text: 'Huddle',
                path: '/huddle',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Huddle
            },
            {
                text: 'Time Off Requests',
                path: '/time-off',
                icon: 'fa-light fa-circle',
                permission: [
                    PermissionType.VacationRequests,
                    PermissionType.LieuDayRequests,
                    PermissionType.PersonalTimeRequests,
                    PermissionType.FloaterDayRequests,
                    PermissionType.LeaveOfAbsenceRequests,
                    PermissionType.AgencyTimeOffRequests,
                ],
            },
            {
                text: 'Form Requests',
                path: '/change-requests',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InformationChangeRequestsList,
            },
        ]
    },
    {
        text: 'Safety',
        icon: 'fa-light fa-shield',
        path: '',
        expanded: false,
        items: [
            {
                text: 'My Score',
                path: '/checklist-my-score',
                icon: 'fa-light fa-circle',
                permission: [
                    PermissionType.ChecklistCompliance,
                    PermissionType.ChecklistCondition
                ],
            },
            {
                text: 'Assets',
                path: '/assets',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Assets,
            },
            {
                text: 'MHE Checklist',
                path: '/checklist',
                icon: 'fa-light fa-circle',
                permission: [PermissionType.Checklist, PermissionType.ChecklistRepair]
            },
            {
                text: 'Incident Report',
                path: '/incident-report',
                icon: 'fa-light fa-circle',
                permission: PermissionType.IncidentReport
            }
        ]
    },
    {
        text: 'Inbound',
        icon: 'fa-light fa-right-to-bracket',
        path: '',
        expanded: false,
        items: [
            {
                text: 'Calendar',
                path: '/inbound/appointment-calendar',
                icon: 'fa-light fa-circle',
                permission: PermissionType.AppointmentCalendar,
            },
            {
                text: 'My Score',
                path: '/inbound/appointment-score',
                icon: 'fa-light fa-circle',
                permission: [PermissionType.AppointmentAgingScore, PermissionType.InboundProductivityScore, PermissionType.TagsRequiredScore, PermissionType.AppointmentComplianceScore],
            },
            {
                text: 'Appointments',
                path: '/inbound/appointments',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Appointments,
            },
            {
                text: 'Empty Trailers',
                path: '/inbound/empty-check-ins',
                icon: 'fa-light fa-circle',
                permission: PermissionType.EmptyCheckIns,
            },
            {
                text: 'Purchase Orders',
                path: '/inbound/purchase-orders',
                icon: 'fa-light fa-circle',
                permission: PermissionType.PurchaseOrders,
            },
            {
                text: 'Suppliers',
                path: '/inbound/suppliers',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Suppliers,
            },
            {
                text: 'Carriers',
                path: '/inbound/carriers',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Carriers,
            },
        ]
    },
    {
        text: 'Outbound',
        icon: 'fa-light fa-right-from-bracket',
        path: '',
        expanded: false,
        items: [
            {
                text: 'My Score',
                path: '/outbound/my-score',
                icon: 'fa-light fa-circle',
                permission: [
                    PermissionType.MyScoreOrderPlanningMix,
                    PermissionType.MyScorePreProductionOrders,
                    PermissionType.MyScorePostProductionMdt,
                ],
            },
            {
                text: 'Check-Out',
                path: '/outbound/empty-check-outs',
                icon: 'fa-light fa-circle',
                permission: PermissionType.EmptyCheckOuts,
            },
            {
                text: 'Orders',
                path: '/outbound/orders',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Orders,
            },
            {
                text: 'Customers',
                path: '/outbound/customers',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Customers,
            }
        ]
    },
    {
        text: 'Yard Management',
        icon: 'fa-thin fa-truck',
        path: '',
        expanded: false,
        items: [
            {
                text: 'My Score',
                path: '/yard-management/yard-score',
                icon: 'fa-light fa-circle',
                permission: [PermissionType.YardCapacityScore, PermissionType.EmptyTrailerAgingScore, PermissionType.ShuntProductivityScore],
            },
            {
                text: 'Yard Capacity',
                path: '/yard-management/yard-capacity',
                icon: 'fa-light fa-circle',
                permission: PermissionType.YardCapacity,
            },
            {
                text: 'Shunt Management',
                path: '/yard-management/shunt-management',
                icon: 'fa-light fa-circle',
                permission: PermissionType.ShuntManagement,
            },
        ]
    },
    {
        text: 'Invoicing',
        icon: 'fa-duotone fa-thin fa-dollar-sign',
        path: '',
        expanded: false,
        items: [
            {
                text: 'My Score',
                path: '/invoicing/my-score',
                icon: 'fa-light fa-circle',
                permission: [
                    PermissionType.MyScoreVendors,
                    PermissionType.MyScoreOperationsL1,
                    PermissionType.MyScoreOperationsL2,
                    PermissionType.MyScoreOperationsL3,
                    PermissionType.MyScoreFinanceInvoices,
                    PermissionType.MyScoreCreditRequests,
                ],
            },
            {
                text: 'PO',
                path: '/invoicing/purchase-orders',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InvoicePurchaseOrders,
            },
            {
                text: 'Invoices',
                path: '/invoicing/invoices',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Invoices,
            },
            {
                text: 'Credit Request',
                path: '/invoicing/credit-requests',
                icon: 'fa-light fa-circle',
                permission: PermissionType.CreditRequests,
            },
            {
                text: 'Vendors',
                path: '/invoicing/vendors',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Vendors,
            },
        ]
    },
    {
        text: 'Productivity',
        icon: 'fa-light fa-suitcase',
        path: '',
        expanded: false,
        items: [
            {
                text: 'Performance',
                path: '/productivity/performance',
                icon: 'fa-light fa-circle',
                permission: PermissionType.Performance,
            },
            {
                text: 'My Score',
                path: '/productivity/efficiency',
                icon: 'fa-light fa-circle',
                permission: PermissionType.NextView,
            },
            {
                text: 'Year to Date',
                path: '/productivity/year-to-date',
                icon: 'fa-light fa-circle',
                permission: PermissionType.YearToDate,
            },
        ]
    },
    {
        text: 'Inventory',
        icon: 'fa-thin fa-box',
        path: '',
        expanded: false,
        items: [
            {
                text: 'Facility Utilization',
                path: '/inventory/utilization',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryFacilityUtilization,
            },
            {
                text: 'Materials',
                path: '/inventory/materials',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryMaterials,
            },
            {
                text: 'HALB',
                path: '/inventory/halb',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryHALB,
            },
            {
                text: 'Storage Bins',
                path: '/inventory/storage-bins',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryBins,
            },
            {
                text: 'Storage Units',
                path: '/inventory/storage-units',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnits,
            },
            {
                text: '210 Damaged',
                path: '/inventory/damaged',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnits210,
            },
            {
                text: '216 Missing',
                path: '/inventory/missing',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnits216,
            },
            {
                text: '260 Putaway',
                path: '/inventory/putaway',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnits260,
            },
            {
                text: '999 Cycle Count',
                path: '/inventory/cycle-count',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnits999,
            },
            {
                text: 'LT22 Refill',
                path: '/inventory/refill',
                icon: 'fa-light fa-circle',
                permission: PermissionType.InventoryStorageUnitsLT22,
            },
            {
                text: 'Blocked Stock',
                path: '/inventory/blocked-stock',
                icon: 'fa-light fa-circle',
                permission: PermissionType.BlockedStock,
            },
            {
                text: 'MB51',
                path: '/inventory/mb51',
                icon: 'fa-light fa-circle',
                permission: PermissionType.MB51,
            }
        ]
    },
    {
        text: 'Settings',
        icon: 'fa-light fa-gear',
        path: '',
        expanded: false,
        items: [
            {
                text: 'Users',
                path: '/users',
                icon: 'fa-light fa-circle',
                permission: PermissionType.UserList,
            },
            {
                text: 'User Roles',
                path: '/roles',
                icon: 'fa-light fa-circle',
                permission: PermissionType.UserRoles
            },
            {
                text: 'Employee Shifts',
                path: '/shifts',
                icon: 'fa-light fa-circle',
                permission: PermissionType.EmployeeShifts
            },
            {
                text: 'Emails',
                icon: 'fa-light fa-circle',
                path: '',
                expanded: false,
                permission: PermissionType.Emails,
                items: [
                    {
                        text: 'Templates',
                        path: '/email-templates',
                        icon: 'fa-light fa-circle',
                        permission: PermissionType.Emails
                    },
                    {
                        text: 'Logs',
                        path: '/email-logs',
                        icon: 'fa-light fa-circle',
                        permission: PermissionType.Emails
                    }
                ]
            },
            {
                text: 'Facility Capacity',
                path: '/inventory/facility-capacity',
                icon: 'fa-light fa-circle',
                permission: PermissionType.FacilityCapacity
            },
            {
                text: 'SLA',
                path: '/inventory/sla',
                icon: 'fa-light fa-circle',
                permission: PermissionType.SLA
            },
            {
                text: 'Productivity Settings',
                path: '/productivity-settings',
                icon: 'fa-light fa-circle',
                permission: PermissionType.ProductivitySettings
            },
            {
                text: 'GL Codes',
                path: '/gl-codes',
                icon: 'fa-light fa-circle',
                permission: [PermissionType.GlCodes, PermissionType.GlCodesClients],
            },
            {
                text: 'Service Types',
                path: '/service-types',
                icon: 'fa-light fa-circle',
                permission: PermissionType.ServiceTypes
            },
            {
                text: 'Conversion Rate',
                path: '/conversion-rates',
                icon: 'fa-light fa-circle',
                permission: PermissionType.ConversionRates
            },
            {
                text: 'Must Depart Times',
                path: '/must-depart-times',
                icon: 'fa-light fa-circle',
                permission: PermissionType.MustDepartTimes
            },
        ]
    }
];
